import react from "react";

const ManageAccount = () => {
    const handleDeleteAccount = () => {
        const confirmDelete = window.confirm("Are you sure you want to delete your account? This action cannot be undone.");
        if(confirmDelete) {
            const token = window.localStorage.getItem('guideToken');
            fetch(`${process.env.REACT_APP_API_URL}/guide/delete-guide-account`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                if(data.success) {
                    alert("Your account has been deleted.");
                    window.localStorage.removeItem('guideToken');
                    window.localStorage.removeItem('guideTokenExpiry');
                    window.location.replace("/");
                } else {
                    alert("There was an error deleting your account: " + data.message);
                }
            })
            .catch(error => {
                console.error("Error deleting account:", error);
                alert("An unexpected error occurred. Please try again later.");
            });
        }
    };
    return (
        <div style={{padding: '20px', textAlign: 'center'}}>
            <p>Do you want to delete your account?</p>
            <button onClick={handleDeleteAccount} style={{backgroundColor: '#dc3545', color: '#fff', padding: '10px 20px', fontSize: '16px', cursor: 'pointer'}}>Delete Account</button>
        </div>
    );
}

export default ManageAccount;